import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/accident-help", label: "Accident? What to do" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const PHONE_DISPLAY = "1800 957 474";
export const PHONE_TEL = "tel:1800957474";

export default function Header() {
  const [open, setOpen] = useState(false);

  const navClass = ({ isActive }) =>
    `px-3 py-2 min-h-[48px] inline-flex items-center text-sm font-medium border-b-2 transition-colors ${
      isActive
        ? "text-ink border-road"
        : "text-steel border-transparent hover:text-ink hover:border-road"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-mist shadow-[0_1px_2px_rgba(23,25,28,0.04)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20 gap-4">
          <Link to="/" className="flex items-center shrink-0" data-testid="header-logo-link">
            <img
              src="/assets/reliance-logo.png"
              alt="Reliance Motor Claims Recovery"
              className="h-8 sm:h-10 w-auto"
              width="668"
              height="90"
            />
          </Link>

          <nav className="hidden md:flex items-center" aria-label="Main navigation">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={navClass}
                data-testid={`nav-${item.to === "/" ? "home" : item.to.slice(1)}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={PHONE_TEL}
              className="hidden lg:inline-flex items-center gap-2 min-h-[48px] px-3 text-sm font-semibold text-ink hover:underline decoration-road decoration-2 underline-offset-4"
              data-testid="header-phone-link"
            >
              <Phone className="size-4" aria-hidden="true" />
              {PHONE_DISPLAY}
            </a>
            <a
              href="/claim"
              className="hidden sm:inline-flex items-center justify-center min-h-[48px] px-5 py-2.5 bg-ink text-white font-saira font-semibold text-sm sm:text-base rounded hover:bg-black transition-colors"
              data-testid="header-start-claim-button"
            >
              Start your claim
            </a>
            <button
              type="button"
              className="md:hidden inline-flex items-center justify-center min-h-[48px] min-w-[48px] text-ink"
              aria-label={open ? "Close menu" : "Open menu"}
              aria-expanded={open}
              onClick={() => setOpen(!open)}
              data-testid="mobile-menu-toggle"
            >
              {open ? <X className="size-6" /> : <Menu className="size-6" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav
          className="md:hidden border-t border-mist bg-white px-4 pt-2 pb-4"
          aria-label="Mobile navigation"
          data-testid="mobile-menu"
        >
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `flex items-center min-h-[48px] px-2 text-base font-medium border-l-4 ${
                  isActive ? "text-ink border-road bg-mist/50" : "text-steel border-transparent"
                }`
              }
              data-testid={`mobile-nav-${item.to === "/" ? "home" : item.to.slice(1)}`}
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href="/claim"
            className="mt-3 flex items-center justify-center min-h-[48px] px-5 py-3 bg-ink text-white font-saira font-semibold rounded"
            data-testid="mobile-menu-start-claim-button"
          >
            Start your claim
          </a>
        </nav>
      )}
    </header>
  );
}
